import style from '@theme/js/components/common/ChangeForm/ChangeForm.scss';
import React, { Fragment, memo, useCallback, useEffect, useState } from 'react';
import { ReCaptcha } from '@core/js/components/main/ReCaptcha';
import { ChangeFormField } from '@core/js/components/common/ChangeForm/components/ChangeFormField';
import { clsb } from '@core/js/utils/classNames.util';
import { useSwissErrors } from '../../hooks/useSwissHooks';
import * as helpers from './helpers';

export const ChangeFormList = memo(({
         fields,
         hiddenByRulesFields,
         isReCaptchaVisible,
         submitButton,
         validationOperation,
         onReCaptchaTokenValidate,
         onReCaptchaTokenError,
         submitting,
         isLoading,
         formName,
         touched,
         handleSubmit,
         formConfig,
         formIdName,
         combinedInitialValues,
         setSubmitButton,
         classNames,
         swissFormat,
         requiredValidationMessages
}) => {
    const buildCls = clsb([style, classNames]);
    const errors = useSwissErrors();
    const [fieldsValidation, setFieldsValidation] = useState([]);
    const [swissErrors, setSwissErrors] = useState([]);
    const requiredMessages = requiredValidationMessages();

    const submitAction = useCallback((event, field) => {
        setSubmitButton?.(field.name);
        handleSubmit(event);
        const notRequiredErrors = helpers.findNotRequiredErrors(fieldsValidation, requiredMessages);
        setSwissErrors(notRequiredErrors);

        if (notRequiredErrors?.filter(el => el.showError)?.length === 0) {
            const resultWithRequiredErrors = helpers.findAllRequiredErrors(fieldsValidation, requiredMessages);

            let firstErrorFound = false;
            const filteredErrorResult = resultWithRequiredErrors.map(item => {
                if (item.showError && !firstErrorFound) {
                    firstErrorFound = true;
                    return item;
                }
                return { ...item, showError: false };

            });

            setSwissErrors(filteredErrorResult);
        }
    }, [setSubmitButton, handleSubmit, fieldsValidation, requiredMessages]);

    useEffect(() => {
        setFieldsValidation(() => swissFormat());
    }, [swissFormat]);

    useEffect(() => {
        setSwissErrors(() => errors());
    }, [fields]);

    return (
        <div className={style.formInnerWrapper}>
            {fields.map((field) => {
                const isFieldHidden = hiddenByRulesFields.includes(field.name);
                return (
                    <Fragment key={field.name}>
                        {!isFieldHidden && isReCaptchaVisible && submitButton === field.name ? (
                            <div className={buildCls(['captcha'])}>
                                <ReCaptcha
                                    operation={validationOperation}
                                    onValidate={onReCaptchaTokenValidate}
                                    onError={onReCaptchaTokenError}
                                />
                            </div>
                        ) : null}
                        <ChangeFormField
                            fields={fields}
                            fieldsValidation={fieldsValidation}
                            setFieldsValidation={setFieldsValidation}
                            formName={formName}
                            submitButton={submitButton}
                            touched={touched}
                            isUpdateMyDetails={formIdName === 'updatemydetails'}
                            initialValues={combinedInitialValues}
                            field={field}
                            formID={formConfig.id}
                            handleSubmit={handleSubmit}
                            isFieldHidden={isFieldHidden}
                            setSubmitButton={setSubmitButton}
                            disabled={submitting || isLoading}
                            submitAction={submitAction}
                            swissErrors={swissErrors}
                            setSwissErrors={setSwissErrors}
                            requiredMessages={requiredMessages}
                        />
                    </Fragment>
                );
            })}
        </div>);
});
